import React from 'react'
import moment from 'moment'

import { Box, List, ListItem, ListItemAvatar, Avatar, Tooltip, ListItemText, Grid, Typography, Divider } from '@material-ui/core'

export const TabPanel = (props) => {
  const { value, index, comments, classes, history } = props

  const getActualDate = (comment) => {
    const date = new Date(comment.timestamp)
    const actualDate = `${(date.getMonth() + 1)}/${date.getDate()}/${date.getFullYear()}`

    return actualDate
  }

  const getActualTime = (comment) => {
    const date = new Date(comment.timestamp)
    const actualTime = moment(date).format('LTS')

    return actualTime
  }
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`accordion-${index}`}
      aria-labelledby={`acccordion-${index}`}
    >
      {value === index && (
        <Box>
          {index === 0
            ? (
              <List>
                {comments.length !== 0
                  ? (
                    comments.map((comment, index) => {
                      return (
                        <ListItem key={`comment ${index}`}>
                          <ListItemAvatar>
                            <Tooltip title={`${comment.firstName} ${comment.lastName}`} placement='top'>
                              <Avatar className={classes.commentAvatar} src={comment && comment.avatarPath ? `${comment.avatarPath}?${new Date().getTime()}` : ''}>
                                {comment && comment.avatarPath ? (<></>) : comment.firstName.substring(0, 1)}{comment.lastName.substring(0, 1)}
                              </Avatar>
                            </Tooltip>
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <Grid container>
                                <Grid item container direction='column' spacing={2}>
                                  <Grid item container alignContent='center' className='pb-0'>
                                    <Typography variant='body1' className='font-weight-bold text-wrap'>{comment.firstName} {comment.lastName}</Typography>
                                  </Grid>
                                  <Grid item container alignContent='center' className='pt-0'>
                                    <Grid item container direction='row'>
                                      <Grid item xs={6}>
                                        <Typography variant='caption' className='text-muted'>
                                          {getActualTime(comment)}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={6}>
                                        <Typography variant='caption' className='text-muted'>
                                          {getActualDate(comment)}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            }
                            secondary={
                              <Grid container>
                                <Grid container direction='row'>
                                  <Typography component='span' variant='body2' className='text-wrap w-100'>{comment.comment}</Typography>
                                </Grid>
                              </Grid>
                            }
                            className='text-dark'
                            disableTypography
                          />
                        </ListItem>
                      )
                    })
                  )
                  : (
                    <ListItem>
                      <Grid container justify='center'>
                        <Typography>No Comments for this Violation</Typography>
                      </Grid>
                    </ListItem>
                  )}
              </List>
            )
            : (
              <List>
                {history.length !== 0
                  ? (
                    history.map((item, index) => {
                      return (
                        <div key={`history item ${index}`}>
                          <ListItem>
                            <ListItemAvatar>
                              <Tooltip title={`${item.firstName} ${item.lastName}`} placement='top'>
                                <Avatar className={classes.commentAvatar} src={item.avatarPath}>
                                  {item.firstName.substring(0, 1)}{item.lastName.substring(0, 1)}
                                </Avatar>
                              </Tooltip>
                            </ListItemAvatar>
                            <ListItemText
                              className='text-dark'
                              disableTypography
                              primary={
                                <Grid container>
                                  <Grid item xs={9} container direction='row'>
                                    <Typography variant='body1' className='font-weight-bold text-wrap w-100'>{item.firstName} {item.lastName}</Typography>
                                  </Grid>
                                </Grid>
                              }
                              secondary={
                                <Typography component='span' variant='body2' className='text-wrap w-100'>
                                  <span className='text-capitalize'>{item.historyAction}</span> on
                                  <span className='text-primary font-italic'> {moment.unix(item.timestamp).format('MMMM Do YYYY, h:mma')}</span>
                                </Typography>
                              }
                            />
                          </ListItem>
                          <Divider variant='inset' component='li' />
                        </div>
                      )
                    })
                  )
                  : (
                    <ListItem>
                      <Grid container justify='center'>
                        <Typography>No History for this Violation</Typography>
                      </Grid>
                    </ListItem>
                  )}
              </List>
            )}
        </Box>
      )}
    </div>
  )
}
